var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "pddPrinting-new" } }, [
    _c(
      "div",
      {},
      [
        _c("dataSummary", {
          attrs: {
            accountList: _vm.accountList,
            addtionalServiceOpts: _vm.addtionalServiceOpts,
            sourceOpts: _vm.sourceOpts,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }